import { configureStore } from '@reduxjs/toolkit';
import memberFormReducer from "../components/member/memberFormSlice";
import memberFilesReducer from "../components/member/memberFilesSlice";
import eLibrarySliceReducer from "../components/eLibrary/eLibrarySlice";
import downloadsSliceReducer from "../components/downloads/downloadsSlice";
import loginSliceReducer from "../components/login/loginSlice";
import globalReducer from "../components/global/globalSlice";

const store = configureStore({
  reducer: {
    memberFilesState: memberFilesReducer,
    memberFormState: memberFormReducer,
    eLibraryState: eLibrarySliceReducer,
    downloadsState: downloadsSliceReducer,
    loginState: loginSliceReducer,
    globalState: globalReducer,
  },
})

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
